// extracted by mini-css-extract-plugin
module.exports = {"column":"column__column___1w3OY","column__value":"column__column__value___3Vyp9","column__label":"column__column__label___1NrbF"};